import { apiHost } from '../../../config';
import { put } from '../../requests';
import School from '../../../types/School';

export default async function updateSchool(
  id: number,
  school: Partial<Omit<School, 'id'>>,
) {
  return put(`${apiHost}/api/admin/schools/${id}`, school);
}
